import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const FAQS = [
  {
    q: 'Does Piua AI store what I type?',
    a: 'Your conversations are saved to your account so you can find them again — but before any message reaches the underlying AI model, personal and company-identifying details are automatically stripped out or replaced. The model itself never sees who you really are.',
  },
  {
    q: "What happens if I don't renew my plan?",
    a: "You'll get reminder emails as your renewal date approaches, highlighting how many days remain, your plan, and the amount due, well before anything changes. If a plan lapses without payment, access is paused until it is renewed; nothing is deleted.",
  },
  {
    q: 'Can I switch between plans?',
    a: 'Yes. You can upgrade to an Advanced plan at any time, and downgrade back to a base plan whenever you choose to.',
  },
  {
    q: 'How does billing work for organizations?',
    a: "One organization account covers every team member added to it. Only organization administrators can manage billing, add or remove team members, and change the organization's plan — regular team members simply chat.",
  },
  {
    q: 'What if a team member leaves?',
    a: "An administrator can suspend or delete their account immediately from the organization's user management page, without disrupting anyone else on the team.",
  },
  {
    q: 'Is there a limit to how many people I can add to my organization?',
    a: 'The Enterprise plan supports up to 15 team members. Enterprise Advanced has no limit.',
  },
  {
    q: 'Do I need to install anything?',
    a: 'No. Piua AI runs entirely in your browser — sign in from any device and your conversations follow you.',
  },
  {
    q: 'Can I export my data?',
    a: 'Yes. Download any conversation as a PDF or JSON file, or request a full email export covering a specific date range, at any time from your account settings.',
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className="card overflow-hidden">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-4 p-6 text-left"
      >
        <span className="text-sm font-semibold text-ink dark:text-white">{item.q}</span>
        <FiChevronDown
          className={`flex-none text-subtle transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-600' : ''}`}
        />
      </button>
      <div
        className="grid grid-cols-1 transition-all duration-300 ease-in-out"
        style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <p className="px-6 pb-6 text-sm leading-relaxed text-muted dark:text-subtle">{item.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-surface py-24 dark:bg-midnight-800">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading eyebrow="FAQ" title="Frequently asked questions" />

        <div className="flex w-full max-w-3xl flex-col gap-4">
          {FAQS.map((item, index) => (
            <Reveal key={item.q} delay={index * 0.04}>
              <FaqItem
                item={item}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
